module.exports = __webpack_public_path__ + "static/media/user.15eeae14.svg";